import { createStyles, makeStyles, Theme } from '@material-ui/core';

const RecordPreviewStyles = makeStyles(({ breakpoints, ...theme }: Theme) => createStyles({
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    background: '#FFF',
  },
  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    height: '65vh',
    width: '90vw',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 'auto',
    justifyContent: 'space-between',
    overflow: 'unset',
    textAlign: 'center',
    flexDirection: 'column',
    [breakpoints.down('sm')]: {
      padding: 'unset',
    },
  },
  header: {
    color: '#FFF',
    padding: '20px 24px 20px 24px',
  },
  title: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#FFF',
    fontSize: 24,
    letterSpacing: 0.31,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    paddingBottom: 10,
    [breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  text: {
    fontSize: 16,
  },
  uploaded: {
    fontSize: 16,
  },
  backdrop: {
    background: 'rgba(0,0,0,0.85)',
  },
  paperRoot: {
    background: 'transparent',
    boxShadow: 'unset',
    height: '100%',
    [breakpoints.down('md')]: {
      width: '100%',
      margin: 'unset',
      maxHeight: 'unset',
    },
  },
  recordPreviewContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'hidden',
    position: 'relative',
  },
  noselect: {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  playerWrapper: {
    maxWidth: '100%',
    height: '100%',
  },
  feelRecord: {
    width: '100%',
    padding: '24px 31px',
    backgroundColor: theme.palette.studio.background,
    color: '#fff',
  },

  // moodContainer:{
  //
  // },

  button: {
    border: `1px solid ${theme.palette.studio.borderColor}`,
    borderRadius: '3px',
    color: '#FFF',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: 'rgba(81,91,106,0.5)',
    },
    padding: '9px 61px',
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    height: 'fit-content',
    width: 'auto',
  },

  loadingFrame: {
    position: 'absolute',
  },

  input: {
    color: '#fff',
    fontSize: '1rem',
    marginBottom: '23px',
    width: '90%',
    '& label.MuiFormLabel-root': {
      color: '#fff',
    },
    '& label.Mui-focused': {
      color: '#fff',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#747C99',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
      borderBottomColor: '#747C99',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#fff',
      },
      '&:hover fieldset': {
        borderColor: '#fff',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fff',
      },
    },
    '& .MuiInputBase-input': {
      color: '#fff',
    },
  },
}), { name: 'RecordPreview' });

export default RecordPreviewStyles;
